const bannerPlayer = new Plyr('#banner-player');

const orgaSwiper = new Swiper('#org-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 30,
  loop: true,

  breakpoints: {
    1: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 'auto',
      spaceBetween: 30,
    },
  },
});

const newsSwiper = new Swiper('#news-swiper', {
  slidesPerView: 3,
  spaceBetween: 30,
  loop: true,
  navigation: {
    nextEl: '#news-swiper-next',
    prevEl: '#news-swiper-prev',
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

const teamSwiper = new Swiper('#team-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 82,
  loop: true,
  navigation: {
    nextEl: '#team-swiper-next',
    prevEl: '#team-swiper-prev',
  },
});

const testimonyPlayer = new Plyr('#player-testimony');

const visitSwiper = new Swiper('#visite-swiper', {
  slidesPerView: 3,
  spaceBetween: 20,

  navigation: {
    nextEl: '#visite-swiper-next',
    prevEl: '#visite-swiper-prev',
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});
